import { ComponentStyleConfig } from '@chakra-ui/react'

import { textStyles } from '../foundations/typography'

export const Text: ComponentStyleConfig = {
  sizes: textStyles.headers,
}
